import { useIntegrationContext } from '@aibees/elephant/components/export-dialog/context/integration-context';
import { useTableActionContext } from '@aibees/elephant/context';
import {
  IntegrationCampaign,
  IntegrationType,
} from '@aibees/elephant/types/integration';
import { TaskData } from '@aibees/shared/api';
import { ErrorResponse } from '@aibees/shared/definition';
import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from '@tanstack/react-query';
import { useMemo } from 'react';
import { useBrowseCampaignApi } from './use-browse-campaign-api';
import { useIntegrationTypeName } from './use-integration-type-name';

interface UseInfiniteCampaignsResult {
  campaigns?: IntegrationCampaign[];
  refetch: <TPageData>(
    options?: RefetchOptions & RefetchQueryFilters<TPageData>
  ) => Promise<QueryObserverResult<TaskData, ErrorResponse>>;
  isLoading: boolean;
}

export const useInfiniteCampaigns = (
  search?: string
): UseInfiniteCampaignsResult => {
  const { selectedIntegration, setSelectedCampaign } = useIntegrationContext();
  const { integrationConfig } = useTableActionContext();
  const integrationType = useIntegrationTypeName(integrationConfig?.type);

  // Create the params object to ensure it updates when selectedIntegration changes
  const params = useMemo(
    () => ({
      id: selectedIntegration?.id,
      type: integrationType as IntegrationType,
      search,
      size: 25,
    }),
    [selectedIntegration?.id, integrationType, search]
  );

  const { data, isLoading, refetch } = useBrowseCampaignApi(params, {
    enabled: !!selectedIntegration?.id,
  });

  if (!data?.content) {
    setSelectedCampaign(undefined);
  }

  return {
    campaigns: data?.content,
    refetch,
    isLoading,
  };
};
